

<div class="courtesy-home">
    <div>
        <img src="../../../assets/images/courtesy-home-image/workingprogress.jpg" alt="">
    </div>
    <h1>Sito in Manutenzione</h1>
    <p>Scusaci per l'incoveniente. Stiamo lavorando per migliorare il servizio.</p>
    <p>Saremo di nuovo attivi entro breve.</p>
    <p style="margin-top: 40px; font-size: 14px; color: #666"><em></em></p>
</div>